module.exports = __webpack_public_path__ + "school2.57d79452.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/school2.png
// module id = kHdb
// module chunks = 0